import { Component } from '@angular/core';
import {
    Autocomplete,
    AutocompleteOption,
    Button,
    Card,
    Dropdown,
    Input,
    Playlist,
    Template,
    ZoneData,
} from '@ntv360/component-pantry';
import { TableComponent } from '@shared';
import { LICENSE_COLUMNS, LICENSE_DATA } from '../../constants/single-screen-tables.constants';

@Component({
    selector: 'app-single-screen',
    imports: [Card, Template, Input, Autocomplete, Button, Dropdown, TableComponent],
    templateUrl: './single-screen.component.html',
    styleUrl: './single-screen.component.scss',
})
export class SingleScreenComponent {
    /** Mock options for dropdowns */
    public mockDropdownConfig = {
        options: [
            { value: 'p1', label: 'Playlist 1' },
            { value: 'p2', label: 'Playlist 2' },
            { value: 'p3', label: 'Playlist 3' },
        ],
        placeholder: 'Dropdown',
        fullWidth: true,
    };

    /** Autocomplete options for Screen Type */
    public screenTypeOptions: AutocompleteOption[] = [
        { value: 'indoor', label: 'Indoor' },
        { value: 'outdoor', label: 'Outdoor' },
        { value: 'kiosk', label: 'Kiosk' },
        { value: 'digital-signage', label: 'Digital Signage' },
    ];

    public playlists: Playlist[] = [
        {
            id: 'main-playlist',
            name: 'Main Content',
            contents: [
                {
                    id: 'c1',
                    title: 'Entertainment',
                    type: 'IMAGE',
                    src: 'https://images.unsplash.com/photo-1514525253361-bee8d4885a0c?q=80&w=1000&auto=format&fit=crop',
                    duration: 10,
                },
            ],
        },
        {
            id: 'sidebar-playlist',
            name: 'Sidebar',
            contents: [
                {
                    id: 'c2',
                    title: 'Info',
                    type: 'IMAGE',
                    src: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1000&auto=format&fit=crop',
                    duration: 10,
                },
            ],
        },
        {
            id: 'ticker-playlist',
            name: 'Ticker',
            contents: [
                {
                    id: 'c3',
                    title: 'Ad',
                    type: 'IMAGE',
                    src: 'https://images.unsplash.com/photo-1614850523296-e8c041df21add?q=80&w=1000&auto=format&fit=crop',
                    duration: 10,
                },
            ],
        },
    ];

    public myZones: ZoneData[] = [
        {
            id: 'main-zone',
            name: 'Main Content',
            playlistId: 'main-playlist',
            xPos: 0,
            yPos: 0,
            width: 1620,
            height: 870,
            zIndex: 1,
            backgroundColor: '#1e2124',
            containerWidth: 1920,
            containerHeight: 1080,
        },
        {
            id: 'sidebar-zone',
            name: 'Sidebar',
            playlistId: 'sidebar-playlist',
            xPos: 1620,
            yPos: 0,
            width: 300,
            height: 870,
            zIndex: 1,
            backgroundColor: '#2e3136',
            containerWidth: 1920,
            containerHeight: 1080,
        },
        {
            id: 'ticker-zone',
            name: 'Ticker',
            playlistId: 'ticker-playlist',
            xPos: 0,
            yPos: 870,
            width: 1920,
            height: 210,
            zIndex: 1,
            backgroundColor: '#003366',
            containerWidth: 1920,
            containerHeight: 1080,
        },
    ];

    /** Columns for the licenses table */
    public licenseColumns = LICENSE_COLUMNS;

    /** Data for the licenses table */
    public licenseData = LICENSE_DATA;
}
